// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__nySdU {
  display: flex;
  align-items: center;
  gap: 4px;

  background-color: var(--colorWhite);
  color: var(--colorGrey900);
}
`, "",{"version":3,"sources":["webpack://./src/components/ListingTag/ListingTag.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,mCAAmC;EACnC,0BAA0B;AAC5B","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  background-color: var(--colorWhite);\n  color: var(--colorGrey900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__nySdU`
};
export default ___CSS_LOADER_EXPORT___;
